require('./viewModes.less');

var Marionette = require('marionette'),
    Backbone = require('backbone'),
    DocModeContainer = require('./docMode/docModeContainer'),
    PgModeContainer = require('./pageMode/pgModeContainer'),
    PDFModeContainer = require('./pdfMode/pdfContainer'),
    NoPagesView = require('./noPagesOverlay/view');

require('backbone.mousetrap');
require('backbone.radio');


/**
 * Not using composite view -- want this rendered prior to rendering the pages
 * (don't know scale b/f hand )
 */

var lChEventFwds =
    [   'noteSaved', 'expandedNoteChange', 'activeNoteSubTypeChange', 'toggleHighlightedNote',
        'noteDeleted', 'setDrawColor', 'setStrokeWidth', 'closeCanvasDialogs',
        'graphicStampChanged', 'consultGroupChange', 'applyAllRedactionsToggled', 'repositionShapeDialog', 'reRenderShapes'
    ];


module.exports = Marionette.LayoutView.extend({
    className: 'FV-center-inner',
    template: require('./modeContainers.hbs'),
    onRender: Backbone.View.prototype.unwrap,

    /**
     * @param options: vChannel, initialViewMode, channelName
     * Temp -- make sub app ... not much comm -- if just extend
     * TODO:
     * - if just extend, doesn't put on Radio proto -- doesn't have a channel itself -- so can't use Radio top level API
     * - want to listen off channel for testing -- no explicit reference to know
     */
    initialize: function(options) {

        _.extend( this, Backbone.Radio.Channel.prototype, options );

        /*
         * Bridge For Forwarding Viewer Events to the Page Canvas (not calling directly on it)
         * TODO: should rename to canvas channel or something or use the mixed in channel.
         * -- this get's wired to pageCanvas channel's ( clean up ; I don't think all are necessary
         * why do we care about this commands ???
         */
        this.viewMdsCh = Backbone.Radio.channel('viewCanvasBridge: ' + this.cid);

        Backbone.fwdFnsOnObjAsFn.apply(this, [this.viewMdsCh, 'trigger', lChEventFwds, this.commands]);

        this.comply(this.commands, this);
        this.reply(this.requests, this);

    },
    regions: {
        docModeContainer:   '.FV-region-docMode',
        pgModeContainer:    '.FV-region-pgMode',
        pdfContainer:       '.FV-region-pdfMode',
        noPagesOverlay:     '#noPagesOverlay'
    },
    serializeData: function() {
        return {
            viewModeClass: this.initialViewMode + '-mode', // the initial viewMode
            documentHasNoPages: this.documentHasNoPages
        };
    },
    commands: {

        // Note: filtered for drawable notes
        activeNoteChange: function(note, options) {

            var pgModeContainer = this.pgModeContainer.currentView;
            pgModeContainer.toggleDrawingMode.apply(pgModeContainer, arguments);

        },

        /**
         * Re-render the shape of the canvas.
         * Intermediate step for floating reason codes - forceDerivisionOfPageModeDomElements:
         * - If 'entering' search and its a floating redaction note, ensure page mode
         * isn't hidden via CSS.  If this is the case, box dimensions are not derived correctly
         * for floating redactions.  Issue encountered and what this resolves ( thus far ), is:
         * If the page was already loaded in page mode, then user moves to another mode, and does a search,
         * upon re-entry to page mode the box sizing is incorrect because boxes don't yet have 'position' ( same now true of adding a search )
         * ( in this case they are drawn at default position, but the DOM hidden ).
         * Tried other solutions but this is by far the simplest.
         * Don't want to muck around with changing CSS for the modes from 'display:none' to 'visibility',
         * as that may break other parts of the application.
         * Could also only do if the page is loaded to emphasize the problem, but this is not intensive and that's probably overkill.
         * Could make generic function if useful in other areas -- eg: could be a solution to 'saving notes' from the hidden
         * canvas view in a different mode, however solution for that is working and fairly simple.
         * New: also necessary for adding and removing searches -- would encounter the same problem.
         */
        redrawCanvasForFindAndRedact: function( findAndRedactSearchModel ) {

            var forceDerivisionOfPageModeDomElements =
                this.vChannel.request('viewMode') !== 'page' && // page hadn't loaded ?
                findAndRedactSearchModel &&
                findAndRedactSearchModel.searchHasResults() &&
                findAndRedactSearchModel.get( 'searchResults' ).hasHitsFromFloatingRedactionNotesOnPage( this.vChannel.request('currentPage').get('pageId') );


            if ( forceDerivisionOfPageModeDomElements ) {
                this.command( 'toggleForceDerivisionOfPageModeDomElements', 1 );
            }


            this.viewMdsCh.trigger('reRenderShapes');


            if ( forceDerivisionOfPageModeDomElements ) {
                this.command( 'toggleForceDerivisionOfPageModeDomElements', 0 );

            }


        },

        toggleForceDerivisionOfPageModeDomElements: function( on ) {
            on
                ? this.$el.addClass('page-mode-not-hidden-and-visible')
                : this.$el.removeClass('page-mode-not-hidden-and-visible');
        },

        renderPgModePgView: function( fullPageModel ) {

            this.pgModeContainer.currentView.renderNewPageView( fullPageModel );

        },
        // Note: synchronous
        renderPDFMode: function(docHasNoPDFRenderablePgs) {

            return this.getRegion('pdfContainer').show( new PDFModeContainer({
                docHasNoPDFRenderablePgs: docHasNoPDFRenderablePgs,
                vChannel: this.vChannel,
                lCh: this.viewMdsCh
            }) );

        },
        // Note: synchronous
        renderNoPagesView: function() {
            return this.getRegion('noPagesOverlay').show( new NoPagesView() ) ;
        },

        /**
         * Blocked from atop if PDF mode.
         * Shouldn't happen but if settings disable Doc Mode and somehow it is set, check to see if it exists --
         * event would be better here ...
         */
        changeScale: function( mode, scale, prevScale, scaleModel, options ) {

            var isDocMode = mode === 'document';

            if ( isDocMode && !this.docModeViewRendered() ) {
                return;
            }

            this.getRegion( (mode === 'document' ? 'doc': 'pg') + 'ModeContainer' )
                .currentView.postScaleChange( scale, prevScale, options );

        },

        // Should trigger off internal channel ...
        scaleTypeChange: function() {
            this.pgModeContainer.currentView.postScaleTypeChange();
        },

        setViewMode: function(mode, prevMode) {
            this.$el.removeClass(prevMode  + '-mode').addClass( mode +  '-mode');
        },


        /**
         * Need to check existence Doc Mode Container Viewer -- with logic current view may not yet be set --
         * or viewer loaded with settings that wouldn't render it.
         * Can now change to Util.blindForward ...
         */
        docModeChangePage: function( loadImages ) {

            Marionette.blindTriggerOn( this.getRegion('docModeContainer').currentView, 'changePage', loadImages );

        }
    },
    requests: {
        docModeViewOfPg: function(pg) {

            if ( !this.docModeViewRendered() ) {
                return null;
            }

            // Here could also use Util.blindForward
            return this.getRegion('docModeContainer').currentView.children.findByModel( pg );
        },
        pgModeView: function() {
            return this.getRegion('pgModeContainer').currentView.getRegion('pageView').currentView;
        },

        renderDocContainer: function( pageCollection ) {

            var docModeRegion = this.getRegion('docModeContainer'),
                vChannel = this.vChannel,
                viewMdsCh = this.viewMdsCh;

            return $.Deferred(function($dfd) {

                 var docModeView = new DocModeContainer({
                     collection: pageCollection,
                     vChannel: vChannel,
                     viewMdsCh: viewMdsCh
                 });
                 docModeView.onShow = _.partial($dfd.resolve, docModeView);
                 docModeRegion.show(docModeView);

            }).promise();

        },

        /* renders the view -- once in main WF to calc scale -- no image is loaded */
        initialPgModeViewRender: function(options) {

           var pgModeRegion = this.getRegion('pgModeContainer'),
               viewMdsCh = this.viewMdsCh;

            return $.Deferred(function($dfd) {
                 var pgModeView = new PgModeContainer( _.extend(options, {
                     viewMdsCh: viewMdsCh
                 }));
                 pgModeView.onShow = _.partial($dfd.resolve, pgModeView);
                 pgModeRegion.show(pgModeView);
            }).promise();

        },
        pdfWrapper: function() {
            return this.viewMdsCh.request('pdfWrapper');
        },
        /**
         * Link to canvas -- current pg of either mode
         * Call of note, scale should be on there ...
         * Now only applicable to page mode -- will get error if use for document and doc mode wasn't created ( docModeViewRendered )
         */
        getCanvasShapeAttrs: function(note, scale, viewMode ) {

            var pageCanvasCh = viewMode === 'document'
                ? this.request( 'docModeViewOfPg', note.getPageModel() ).canvas.pageCanvasCh
                : this.request( 'pgModeView').canvas.pageCanvasCh ;

            return pageCanvasCh.request.apply( pageCanvasCh, ['getShapeAttrsToPersist', note, scale] );

        }

    },

    /** Utilize this here instead of breaking into SubApps and a more
     * obtrusive refactor; this is like an intermediate refactor.
     * Doc Mode may now not exist -- we could employ a better or similar patter for the other mode views,
     * but currently has no reason not to render them.
     * ( Would want for requests -- alternative is events, blindTriggers, and now Util.blindForward ... ).
     */
    docModeViewRendered: function() {
        return this.getRegion('docModeContainer').hasView();

    },

    onBeforeDestroy: function() {

        Backbone.Radio.Channel.prototype.reset.call(this);
        this.viewMdsCh.reset();

    },
    destroy: function() {

        Marionette.LayoutView.prototype.destroy.apply(this, arguments);
        this.$('*').remove();  // clear ref's from jq cache -- el and $el still ref'd

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/viewModesView.js
 ** module id = 412
 ** module chunks = 0
 **/